/**
 * Pure helpers for CategoryCombobox. Kept separate from the component so the
 * matching / create-option rules are unit-testable without a DOM.
 */

/** Trim + collapse inner whitespace so " Home  Care " and "Home Care" collide. */
export function normalizeCategoryName(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

/** Case-insensitive comparison on the normalized form. */
export function isSameCategory(a: string, b: string): boolean {
  return normalizeCategoryName(a).toLowerCase() === normalizeCategoryName(b).toLowerCase();
}

/** Categories containing the query, case-insensitive. Empty query = all. */
export function filterCategories(categories: string[], query: string): string[] {
  const q = normalizeCategoryName(query).toLowerCase();
  if (!q) return categories;
  return categories.filter((c) => c.toLowerCase().includes(q));
}

/**
 * The typed name to offer as "+ Create ..." — or null when there is nothing to
 * create. Suppressed for a blank query and when the name already exists (an
 * exact match should be picked, not duplicated).
 */
export function createOptionFor(categories: string[], query: string): string | null {
  const name = normalizeCategoryName(query);
  if (!name) return null;
  if (categories.some((c) => isSameCategory(c, name))) return null;
  return name;
}
